<div *ngIf="label" class="control-label label" [class.disabled]="isDisabled" [class.required]="isRequired">
  {{ label }}
</div>
<div class="inputWrap" [ngClass]="{ disabled: isDisabled, 'input__full-width': fullWidth }">
  <input class="input"
         type="text"
         placeholder="{{placeholder}}"
         [(ngModel)]="_value"
         (ngModelChange)="valueChangeHandler($event)"
         (blur)="onTouch()"
         maxlength="{{maxLength}}"
         [ngClass]="{'invalid-field': showError}"
         [disabled]="isDisabled"
         #input />
</div>
<div class="invalid-text" *ngIf="showError">{{ errorMessage }}</div>

